import $ from 'jquery';
import 'slick-carousel';
import MicroModal from 'micromodal';

MicroModal.init();

// Home Hero Slider
const $homeHeroSlider = $('.home-hero-slider');

function runHomeSlider() {
  const consistentHeight = $homeHeroSlider.data('consistentHeight') ?? false;

  // Applies a base theme (group of classes) to the indvidual slider dots
  $homeHeroSlider.on('init', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $('.slide-m-dots-home-hero-slider').data('theme');
      if (theme) {
        dots.addClass(theme);
      }
    }
  });

  // Initialize Hero Slider
  $homeHeroSlider.slick({
    lazyLoad: 'progressive',
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: true,
    adaptiveHeight: !consistentHeight,
    appendDots: $('.slide-m-dots-home-hero-slider'),
    nextArrow: $('.slide-m-next-home-hero-slider'),
    prevArrow: $('.slide-m-prev-home-hero-slider'),
  });
  
  if (consistentHeight) {
    $homeHeroSlider.on('setPosition', function (e, slick) {
      slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });
  }
}

runHomeSlider();

// Reviews Slider
const $homeReviewsSlider = $('.home-reviews-slider');

$homeReviewsSlider.on('init beforeChange', function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find('li');
    const theme = $('.slide-m-dots-home-reviews-slider').data('theme');
    if (theme) {
      dots.addClass(theme);
    }
  }
  $homeReviewsSlider.removeClass('opacity-0');
});

$homeReviewsSlider.slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  infinite: true,
  arrows: true,
  dots: true,
  appendDots: $('.slide-m-dots-home-reviews-slider'),
  nextArrow: $('.slide-m-next-home-reviews-slider'),
  prevArrow: $('.slide-m-prev-home-reviews-slider'),

  responsive: [
    {
      breakpoint: 1536,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '8%',
      },
    },
  ],
});

$homeReviewsSlider.on('setPosition', function (e, slick) {
  slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});

if ($('.body-types-models')) {
  const types = [];

  $('.body-types-models')
    .find('.tab-pane')
    .each(function () {
      types.push($(this).attr('id'));
    });

  types.forEach((type) => {
    const $bodyTypeSlider = $(`.body-type-ctas.${type}`);

    $bodyTypeSlider.on('init beforeChange', function (event, slick) {
      if (slick.$dots) {
        const dots = slick.$dots.find('li');
        const theme = $(`.slide-m-dots-body-type-ctas-${type}`).data('theme');
        if (theme) {
          dots.addClass(theme);
        }
      }
    });

    $bodyTypeSlider.slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: false,
      dots: true,
      arrows: true,
      infinite: true,
      appendDots: $(`.slide-m-dots-body-type-ctas-${type}`),
      nextArrow: $(`.slide-m-next-body-type-ctas-${type}`),
      prevArrow: $(`.slide-m-prev-body-type-ctas-${type}`),
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            // centerMode: true,
            // centerPadding: "8%",
          },
        },
      ],
    });

    $bodyTypeSlider.on('setPosition', function (e, slick) {
      slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });
  });
}

// Ford Pass Slider
const $fordPassSlider = $('.ford-pass-slider');

// Applies a base theme (group of classes) to the indvidual slider dots
$fordPassSlider.on('init', function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find('li');
    const theme = $('.slide-m-dots-ford-pass-slider').data('theme');
    if (theme) {
      dots.addClass(theme);
    }
  }
  $fordPassSlider.removeClass('opacity-0');
});

$fordPassSlider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  appendDots: $('.slide-m-dots-ford-pass-slider'),
  nextArrow: $('.slide-m-next-ford-pass-slider'),
  prevArrow: $('.slide-m-prev-ford-pass-slider'),
});

// Home Hero Slider
const $promoSlider = $('.promo-slider');

// Applies a base theme (group of classes) to the indvidual slider dots
$promoSlider.on('init', function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find('li');
    const theme = $('.slide-m-dots-promo-slider').data('theme');
    if (theme) {
      dots.addClass(theme);
    }
  }
});

$promoSlider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  appendDots: $('.slide-m-dots-promo-slider'),
  nextArrow: $('.slide-m-next-promo-slider'),
  prevArrow: $('.slide-m-prev-promo-slider'),
  adaptiveHeight: true,
  autoplay: true,
});

// Showroom Gallery

$('.showroom-gallery').each(function () {
  const modalID = $(this).data('modal');

  const $showroomGallerySlider = $(`.showroom-gallery-slider-${modalID}`);
  // const $trimCurrentSlide = $(`.showroom-gallery-${modalID}-current-item`);

  $showroomGallerySlider.on('init', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $(`.slide-m-dots-showroom-gallery-slider-${modalID}`).data('theme');
      if (theme) {
        dots.addClass(theme);
      }
    }
  });

  $showroomGallerySlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: true,
    appendDots: $(`.slide-m-dots-showroom-gallery-slider-${modalID}`),
    nextArrow: $(`.slide-m-next-showroom-gallery-slider-${modalID}`),
    prevArrow: $(`.slide-m-prev-showroom-gallery-slider-${modalID}`),
  });

  $showroomGallerySlider.on('setPosition', function (e, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });
});

// Configure Collection Slider
$('.js-trim-modal-open').on('click', function () {
  const modalID = $(this).data('modal');
  MicroModal.show(`modal-${modalID}`);
  $(`.showroom-gallery-slider-${modalID}`).slick('setPosition');
});

$('.collection-slider').each(function () {
  const collection = $(this).data('collection');
  const $configureGallerySlider = $(`.configure-collection-slider-${collection}`);

  $configureGallerySlider.on('init', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $(`.slide-m-dots-configure-collection-slider-${collection}`).data('theme');
      if (theme) {
        dots.addClass(theme);
      }
    }
  });

  $configureGallerySlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: true,
    appendDots: $(`.slide-m-dots-configure-collection-slider-${collection}`),
    nextArrow: $(`.slide-m-next-configure-collection-slider-${collection}`),
    prevArrow: $(`.slide-m-prev-configure-collection-slider-${collection}`),
  });

  $configureGallerySlider.on('setPosition', function (e, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });
});
